import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import { RouterContext } from './router';
import { createMockRouter } from '../helpers';
import type { Query } from '../types';
interface Props {
  pathname?: string;
  query?: Query;
  children: React.ReactNode;
}
export function MockRouterProvider(props) {
  const $ = _c(6);
  const {
    pathname: t0,
    query,
    children
  } = props;
  const pathname = t0 === undefined ? "/" : t0;
  let t1;
  if ($[0] !== pathname || $[1] !== query) {
    t1 = createMockRouter({
      pathname,
      query
    });
    $[0] = pathname;
    $[1] = query;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const router = t1;
  let t2;
  if ($[3] !== children || $[4] !== router) {
    t2 = <RouterContext.Provider value={router}>{children}</RouterContext.Provider>;
    $[3] = children;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}